<template>
  <inertia-link :href="$route('collections.show', collection.uuid)" class="cursor-pointer">
    <div class="pb-full w-full relative">
      <div class="absolute inset-0 rounded-md overflow-hidden">
        <img
          v-if="collection.cover_thumb_url"
          :src="collection.cover_thumb_url"
          :alt="collection.name"
          class="w-full h-full object-cover"
        >
      </div>
    </div>
    <div class="pt-3">
      <h4 class="font-semibold 2xl:text-lg truncate" :title="collection.name">{{ collection.name }}</h4>
      <span
        v-if="collection.items_count > 0"
        class="text-carolina text-sm font-light">
        {{ collection.items_count }} media {{ collection.items_count == 1 ? 'file' : 'files'}}
      </span>
    </div>
  </inertia-link>
</template>
<script>
export default {
  name: 'CollectionComponent',

  props: {
    collection: Object
  },
}
</script>
